<script lang="ts">
   export let value = '';
  export let textarea = null; 
  export let rows = null; 
  export let id = null; 
  export let readonly = null; 
  export let disabled = null;
  export let placeholder = null;
  export let counter: boolean | number = false;

  let focused = false;
  let warnFlag = false
  let timer = null

  function onFocus() {
    focused = true;
  }
  function onBlur() {
    focused = false;
  }
  function clear() {
    value = '';
  }
  function onInput():void {
    if(value.length >= counter && counter) {
      value = value.slice(0, counter as number)
    }
  }

  export function boxWarn():void {
    clearTimeout(timer)
    warnFlag = true
    timer = setTimeout(() => {
      warnFlag = false
    }, 1500)
  }
</script>

<style lang="less" src="./Textarea.less">
</style>

<div class="c-textarea">
  <textarea
    bind:this={textarea}
    style={`border-color: ${warnFlag ? '#db2e20': '#ccc' }`}
    type="text"
    bind:value
    {rows}
    {placeholder}
    {id}
    {readonly}
    {disabled}
    on:focus={onFocus}
    on:blur={onBlur}
    on:input={onInput}
    on:focus
    on:blur
    on:input
    on:change
    {...$$restProps} />
    {#if counter}<span class="c-textarea__counter">{value.length}/{counter}</span>{/if}
</div>